// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__11y3p","row":"ProcedureTreatmentSummary_row__2cLnj"};